import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { AccordionTitlePlaceholder } from './AccordionTitlePlaceholder';
import { useQAResult } from '../QAResult/useQAResult';
import QAContext from '../../context/QAContext';
import { dataModel } from '../dataModel';
import '../QAResult/QAResult.scss';

const AccordionTitleComponent = ({ noSpacing }) => {
  const { TotalResults, qaLoading } = useContext(QAContext);

  useQAResult();

  if (qaLoading) return <AccordionTitlePlaceholder />;

  return (
    <div
      className={`qa-result__accordion ${noSpacing ? 'qa-result__accordion--no-spacing' : ''}`}
    >
      <h3 className="qa-result__accordion-header">
        Questions &amp; Answers
      </h3>
      {TotalResults > 0
        && (
          <div className="qa-result__accordion-subheader">
            <span className="">{ TotalResults } { TotalResults === 1 ? 'Question' : 'Questions' }</span>
          </div>
        )}
    </div>
  );
};

AccordionTitleComponent.displayName = 'QuestionsAnswersAccordionTitle';

AccordionTitleComponent.propTypes = {
  noSpacing: bool
};

AccordionTitleComponent.defaultProps = {
  noSpacing: false
};

AccordionTitleComponent.dataModel = dataModel;

export { AccordionTitleComponent };